import { BrowserRouter, Routes, Route, Navigate } from 'react-router'
import AdminLayout from './nexus/layout/AdminLayout'
import LoginScreen from './components/LoginScreen'
import Dashboard from './pages/Dashboard'
import Analytics from './pages/Analytics'
import Users from './pages/Users'
import UserProfile from './pages/UserProfile'
import Sessions from './pages/Sessions'
import HelpBotSessions from './pages/HelpBotSessions'
import SessionDetail from './pages/SessionDetail'
import Downvotes from './pages/Downvotes'
import Feedback from './pages/Feedback'
import System from './pages/System'
import UATSurvey from './pages/UATSurvey'
import EmailOrganizations from './pages/EmailOrganizations'
import Settings from './pages/Settings'
import RateLimits from './pages/RateLimits'
import AccessBlocks from './pages/AccessBlocks'
import SourceOfTruth from './pages/SourceOfTruth'
import MultiUserOrganizations from './pages/MultiUserOrganizations'
import TermsOfService from './pages/TermsOfService'
import Disclaimer from './pages/Disclaimer'
import { useAuth } from './lib/auth'

function App() {
  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) {
    return <LoginScreen />
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AdminLayout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="users" element={<Users />} />
          <Route path="users/:userId" element={<UserProfile />} />
          <Route path="sessions" element={<Sessions />} />
          <Route path="sessions/:sessionId" element={<SessionDetail />} />
          <Route path="help-bot-sessions" element={<HelpBotSessions />} />
          <Route path="downvotes" element={<Downvotes />} />
          <Route path="feedback" element={<Feedback />} />
          <Route path="system" element={<System />} />
          <Route path="uat-survey" element={<UATSurvey />} />
          <Route path="organizations" element={<MultiUserOrganizations />} />
          {/* The selected organization lives in the URL so it can be linked,
              bookmarked and reached with the back button. */}
          <Route path="organizations/:orgSlug" element={<MultiUserOrganizations />} />
          <Route path="email-organizations" element={<EmailOrganizations />} />
          <Route path="multi-user" element={<Navigate to="/organizations" replace />} />
          <Route path="settings" element={<Settings />} />
          <Route path="rate-limits" element={<RateLimits />} />
          <Route path="access-blocks" element={<AccessBlocks />} />
          <Route path="source-of-truth" element={<SourceOfTruth />} />
          <Route path="terms-of-service" element={<TermsOfService />} />
          <Route path="disclaimer" element={<Disclaimer />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
